import React, { useState } from "react";
import Styles from "../../styles/HomeScreen.module.css";
import BannerComponent from "../../components/BannerComponent";
import { MDBInputGroup, MDBInput ,MDBBtn} from "mdbreact";
import Styles2 from "../../styles/sorting/SortingScreen.module.css";
import TableComponent from "../../components/ML/TableComponent";
import Select from 'react-select';

const options = [
    { value: 'catagorical', label: 'catagorical' },
    { value: 'numerical', label: 'numerical' },
];

const DecisionTreeScreen = () => {

    const [rows, setRows] = useState();
    const [colums, setColumns] = useState();
    const [tableVisible, setTableVisible] = useState(false);
    const [columnNames, setColumnNames] = useState([{ title: "", type: "catagorical" }]);
    const [selectList,setSelectList] = useState([{value:"catagorical",label:"catagorical"}])

    const handleChange = (e) => {
        const name = e.target.name;
        if (name == "rows") {
            setRows(e.target.value);
        }
        else if (name == "columns") {
            setColumns(e.target.value)
            setTableVisible(true);
            let columnNameList = [];
            let selectLst = [];
            for (let i = 0; i < e.target.value; i++) {
                let data = {
                    title: "",
                    field : "",
                    type : "string"
                }
                columnNameList.push(data);
                let sData = {
                    value : "catagorical",
                    label : "catagorical"
                }
                selectLst.push(sData);
            }
            setColumnNames(columnNameList);
            setSelectList(selectLst);
        }
    }

    const handleColumnNameChange = (e, index) => {
        let columnNameList = [...columnNames];
        columnNameList[index].title = e.target.value;
        columnNameList[index].field = e.target.value;
        setColumnNames(columnNameList);
    }

    const handleColumnTypeChange = (e, index) => {
        console.log(e);
        let columnNameList = [...columnNames];
        let selectLst = [...selectList];
        columnNameList[index].type = e.label == "catagorical" ? "string":"numeric";
        setColumnNames(columnNameList);
        
        selectLst[index] = e;
        setSelectList(selectLst); 
        console.table(selectLst);
        // columnNameList[index].type = e.target.value;
        // setColumnNames(columnNameList);
    }

    const handleSubmit = () => {
        console.table(columnNames);
        console.table(selectList);
    }

    return (
        <div className={Styles.container}>
            <BannerComponent header={"DECISION TREE"} />
            <div className={Styles2.sortingContainer} style={{ padding: 30,display:"" }}>
                <MDBInputGroup
                    material
                    containerClassName="m-0"
                    prepend="Number of rows and columns"
                    inputs={
                        <>
                            <MDBInput value={rows} name="rows" onChange={handleChange} noTag type="text" hint="Type no of rows" />
                            <MDBInput value={colums} name="columns" onChange={handleChange} noTag type="text" hint="Type no of columns" />
                        </>
                    }
                />


                
                {
                    tableVisible &&
                    columnNames.map((name, index) => {
                        console.log(columnNames[index].type);
                        return (
                                <div key={index} style={{ display: "flex", flexDirection: "row", width: "31%",margin:10 ,justifyContent:"space-around"}}>
                                    <MDBInput value={columnNames[index].title} style={{ width: "48%" }} name="rows" onChange={(e) => handleColumnNameChange(e, index)} noTag type="text" hint="Type column name" />
                                    <div style={{ width: "48%" }}>
                                        <Select
                                            value={selectList[index]}
                                            onChange={(e) => handleColumnTypeChange(e, index)}
                                            // onChange={handleChange2}
                                            options={options}
                                        />
                                    </div>
                                </div>
                        )
                    })
                }

                <MDBBtn onClick={() => handleSubmit()}>SUBMIT</MDBBtn>



                {
                    tableVisible && <TableComponent columnNames={columnNames} />
                }





            </div>
        </div>
    );
};

export default DecisionTreeScreen;
